
const FooterBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden opacity-10 pointer-events-none">
      <div className="absolute -top-24 -left-24 w-48 md:w-64 h-48 md:h-64 rounded-full bg-blue-400 opacity-20"></div>
      <div className="absolute top-1/3 -right-32 w-72 md:w-96 h-72 md:h-96 rounded-full bg-blue-300 opacity-10"></div>
      <div className="absolute bottom-0 left-1/4 w-64 md:w-80 h-64 md:h-80 rounded-full bg-blue-500 opacity-15"></div>
    </div>
  );
};

export default FooterBackground;
